/*** IMPORTS FROM imports-loader ***/
(function() {

define([
    'jquery',
    'pip-model',
    'pip-events'
],
function(
    $,
    pip,
    pipEvents
){
    var view = {
        selectors: {
            returnsWrapper: '#buybelt__returns-wrapper',
            cannotBeShipped :'.sub_buybelt div:nth-child(2)'
        },
        initEventListeners: function initEventListeners() {
            pipEvents.dualPath.dualPathOptInStateChanged.off('.sub-dualPathStateChanged');
            pipEvents.dualPath.dualPathOptInStateChanged.on('.sub-dualPathStateChanged', function() {
                $(view.selectors.returnsWrapper).toggle(!pip.customer.dualPath.isOptedIn);
                $(view.selectors.cannotBeShipped).toggleClass('sub_buybelt__cannot_be_shipped--border-0', pip.customer.dualPath.isOptedIn)
            });
        }
    }
    
	return {
		init: function init() {
            view.initEventListeners()
		}
	};
});
}.call(window));